/**
 * ขนาด touch target ขั้นต่ำของเครื่องสแกน Android handheld
 *
 * ใช้เป็น inline style เพื่อให้ automated test ตรวจได้จริง (jsdom ไม่โหลด stylesheet)
 * และเพื่อกันการย่อ Desktop UI มาใช้บนหน้างานโดยไม่ปรับขนาดปุ่ม
 */
export const TOUCH_TARGET_MIN_PX = 44;

/** ปุ่มหลักของหน้างานตั้งสูงกว่าขั้นต่ำ เพราะผู้ใช้สวมถุงมือ */
export const PRIMARY_TOUCH_TARGET_PX = 72;

export const touchTargetStyle = {
  minHeight: `${TOUCH_TARGET_MIN_PX}px`,
  minWidth: `${TOUCH_TARGET_MIN_PX}px`,
} as const;

export const primaryTouchTargetStyle = {
  minHeight: `${PRIMARY_TOUCH_TARGET_PX}px`,
  minWidth: `${TOUCH_TARGET_MIN_PX}px`,
} as const;
